import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { ToolbarModule } from 'primeng/toolbar';
import { NgIfPhoneAndTabletDirective } from '../../directives/ng-if-phone-and-tablet/ng-if-phone-and-tablet.directive';
import { NgIfWebDirective } from '../../directives/ng-if-web/ng-if-web.directive';
import { HeaderTabletAndMobileComponent } from './header-tablet-and-mobile/header-tablet-and-mobile.component';
import { HeaderWebComponent } from './header-web/header-web.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    InputTextModule,
    MenubarModule,
    SharedModule,
    ToolbarModule,
    MenuModule,
    ButtonModule,
    HeaderWebComponent,
    HeaderTabletAndMobileComponent,
    NgIfPhoneAndTabletDirective,
    NgIfWebDirective,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {}
